import React from 'react';
export function Footer() {
  return <footer className="bg-brand-card text-gray-500 py-8 px-4 border-t border-white/5" data-id="element-57">
      <div className="max-w-xl mx-auto text-center text-xs" data-id="element-58">
        <p className="mb-2" data-id="element-59">
          El sistema de materiales N°1 para instructores técnicos.
        </p>
        <p className="font-bold text-gray-400" data-id="element-60">
          Porque enseñar instalaciones eléctricas no debería costarte cada
          domingo.
        </p>
      </div>
    </footer>;
}